export default "__VITE_ASSET__BgIWLryU__"